import { render } from "./Buses.vue?vue&type=template&id=264de200&scoped=true"
import script from "./Buses.vue?vue&type=script&lang=js"
export * from "./Buses.vue?vue&type=script&lang=js"

import "./Buses.vue?vue&type=style&index=0&id=264de200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264de200"]])

export default __exports__